module.exports = __webpack_public_path__ + "img/new13.fbd07e08.jpg";